import getUserIdRequest from "./requests/get-user-id-request";
import getContractRequest from "./requests/get-contract-request";
import setContractRequest from "./requests/set-contract-request";
import editPasswordRequest from "./requests/edit-password-request";
import beforeEditPhoneRequest from "./requests/before-edit-phone-request";
import editPhoneRequest from "./requests/edit-phone-request";
import beforeEditFioRequest from "./requests/before-edit-fio-request";
import editFioRequest from "./requests/edit-fio-request";
import editEmailRequest from "./requests/edit-email-request";
import beforeEditEmailRequest from "./requests/before-edit-email-request";
import getMyAccountRequest from "./requests/get-my-account-request";
import getCompanyDataRequest from "./requests/get-company-data-request";
import exitAllPlatformRequest from "./requests/exit-all-platform-request";
import getAgentHistoryRequest from "./requests/get-agent-history-request";
import telegramRequest from "./requests/telegram-request";
import telegramExitRequest from "./requests/telegram-exit-request";
import updateCompanyRequest from "./requests/update-company-request";
import getActHistoryRequest from "./requests/get-act-history-request";
import getBalanceHistoryRequest from "./requests/get-balance-history-request";
import setConfigRequest from "./requests/set-config-request";
import getConfigRequest from "./requests/get-config-request";
import setCompanyDataRequest from "./requests/set-company-data-request";
import setCompanyActiveRequest from "./requests/set-company-active-request";
import deleteCompanyRequest from "./requests/delete-company-request";
import activatePromocodeRequest from "./requests/activate-promocode-request";
import getSmsLogRequest from "./requests/get-sms-log-request";

const userRepository = {
    getUserId: getUserIdRequest,
    getContract: getContractRequest,
    setContract: setContractRequest,
    editPassword: editPasswordRequest,
    beforeEditPhone: beforeEditPhoneRequest,
    editPhone: editPhoneRequest,
    beforeEditFio: beforeEditFioRequest,
    editFio: editFioRequest,
    editEmail: editEmailRequest,
    beforeEditEmail: beforeEditEmailRequest,
    getMyAccount: getMyAccountRequest,
    getCompanyData: getCompanyDataRequest,
    exitAllPlatform: exitAllPlatformRequest,
    getAgentHistory: getAgentHistoryRequest,
    telegram: telegramRequest,
    telegramExit: telegramExitRequest,
    updateCompany: updateCompanyRequest,
    getActHistory: getActHistoryRequest,
    getBalanceHistory: getBalanceHistoryRequest,
    setConfig: setConfigRequest,
    getConfig: getConfigRequest,
    setCompanyData: setCompanyDataRequest,
    setCompanyActive: setCompanyActiveRequest,
    deleteCompany: deleteCompanyRequest,
    activatePromocode: activatePromocodeRequest,
    getSmsLog: getSmsLogRequest,
};

export default userRepository;
